import React from 'react';

import { Icon } from '@rbilabs/components-library';

import IconWrap from './icon-wrap';

export const PickUpIcon: React.FC = () => {
  return (
    <IconWrap aria-hidden>
      <Icon icon="cart" color="icon-active" height="40px" aria-hidden />
    </IconWrap>
  );
};
